import type { Money } from '@/shared/api/types';
import { moneyToInput, parseMoney } from '@/shared/lib/format';

/**
 * Conversoes entre o valor gravado e o texto do campo da parametrizacao.
 *
 * Aqui o vazio tem sentido proprio: e "nao informado", diferente de zero. Por isso o
 * zero gravado aparece como "0", e nao como campo vazio: salvar sem mexer apagaria o
 * parametro, o que seria mudar a configuracao sem ninguem ter decidido.
 */
export function dinheiroParaCampo(valor: Money | null | undefined): string {
  if (!valor) return '';
  return valor.amount === 0 ? '0' : moneyToInput(valor);
}

export function campoParaDinheiro(texto: string): Money | null {
  return texto.trim() === '' ? null : parseMoney(texto);
}

export function inteiroParaCampo(valor: number | null | undefined): string {
  return valor === null || valor === undefined ? '' : String(valor);
}

/** Inteiro de dias ou nulo para vazio. Texto que nao e inteiro volta indefinido. */
export function campoParaInteiro(texto: string): number | null | undefined {
  const limpo = texto.trim();
  if (limpo === '') return null;
  if (!/^\d+$/.test(limpo)) return undefined;
  return Number(limpo);
}

export function erroDeDias(texto: string): string | undefined {
  const valor = campoParaInteiro(texto);
  if (valor === undefined) return 'Use um numero inteiro de dias.';
  if (valor !== null && valor > 36500) return 'O prazo vai ate 36500 dias.';
  return undefined;
}
